exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bannerWrapper___29Jy3 {\n  position: relative;\n}\n", ""]);

// exports
exports.locals = {
	"bannerWrapper": "bannerWrapper___29Jy3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/common/header/UnifiedNav/styles.module.less
// module id = 2198
// module chunks = 71